import React, { useState } from 'react';
import './OnboardingInputs.css';
import { useParams, useSearchParams } from 'react-router-dom';

const ProductSelector = (props) => {
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('user_id') || '1';

  const options = ["Payments", "Contact Info", "Social"];
  const options_labels = props.languageSetting === "ENGLISH" ? {Payments:'Payments', "Contact Info":'Contact Info', Social:'Social'} : {Payments:'Pagos', "Contact Info":'Información De Contacto', Social:'Redes Sociales'};
  const handleOptionClick = (option) => {
    props.onProductSelect(option); // Call parent's function with selected option
  };

  // Set total steps based on user_id
  props.setTotalSteps(userId === '1' ? 4 + props.selectedProducts.length : 3 + props.selectedProducts.length);

  return (
    <div className="option-container" > 
      {options.map((option) => (
        <>
        <div
          key={option}
          onClick={() => handleOptionClick(option)}
          className="option-button" // Apply CSS class
          style={{ backgroundColor: props.selectedProducts.includes(option) ? "#1DBC60" : "#FFFFFF" }}
        >
          {options_labels[option]}
        </div>
        <br/>
        </>
      ))}
    </div>
  );
};

export default ProductSelector;
